import React, { useState, useEffect, useCallback } from "react";
import UserItem from "../../../../Users/components/UserItem";
import EmptyResult from "../../../../../../components/EmptyResult";
import Pagination from "@material-ui/lab/Pagination";
import PaginationItem from "@material-ui/lab/PaginationItem";
import SearchIcon from '@material-ui/icons/Search';
import { useLocation, Link} from "react-router-dom";
import { Grid, InputAdornment, TextField} from "@material-ui/core";
import ProfilesService from "../../../../../../../services/ProfilesService";
import ChipSelection from "./ChipSelection";
import UserSelectableItem from "./UserSelectableItem";
import CoursesService from "../../../../../../../services/CoursesService";
import { calcCountPages, calcOffset } from "../../../../../../../utils/pagination";
import { useDispatch } from "react-redux";
import { showSnackBar } from "../../../../../../../redux/actions/ui";


// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
  return new URLSearchParams(useLocation().search);
}


function ProfileSelection(props){
  const location = useLocation();
  const dispatch = useDispatch();
  const { courseId, role, action } = props;
  let query = useQuery();  
  const PAGINATION_URL = `/dashboard/courses/${courseId}/user-selection`;
  const [usersList, setUsersList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [timer, setTimer] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState(location.state && location.state.selectedUsers ? location.state.selectedUsers : []);
  const [assginedUsers, setAssginedUsers] = useState([]);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const usersLoading = Array.from(Array(usersList.length > 0 ? usersList.length: 5).keys());
  const isActionView = action === 'View';

  const onSearchChanged = e => {
    const value = e.target.value;    
    clearTimeout(timer)
    const newTimer = setTimeout(() => {
      fetchUsersData(value);
    }, 500)
    setTimer(newTimer)
  }
    
  // pagination  
  const [countPages, setCountPages] = useState(location.state && location.state.countPages ? location.state.countPages: 0 );
  const page = parseInt(location.state && location.state.page ? location.state.page: ( query.get("page") || 1)  );
  const paginationLimit = 20;

  const updateCourseStudents = async () => {    
    setIsLoadingSubmit(true);   
    const field = role === 'Student' ? 'students' : 'teachers';
    try{
      // set users
      if(isActionView){
        // Here we removed the users in assginedUsers that are in selectedUsers
        await CoursesService.updateCourse({          
          [field]: assginedUsers.filter((item) => !selectedUsers.some((user) => user.id === item))
        }, courseId);     

        // After that update assignedUsers
        setAssginedUsers(assginedUsers.filter((item) => !selectedUsers.some((user) => user.id === item)))
      }else{
        // Assing to the course
        await CoursesService.updateCourse({
          [field]: [...assginedUsers, ...selectedUsers.map(item => item.id)]          
        }, courseId);

        // After that update assignedUsers
        setAssginedUsers([...assginedUsers, ...selectedUsers.map(item => item.id)]);
      }
      setIsLoadingSubmit(false);            
      dispatch(showSnackBar(`Successfully ${isActionView ? 'Removed': 'Assigned' }!`));      

      handleResetSelectedUsers();
      // We updated the list
      fetchUsersData(); 
    }catch (error) {
      console.log("Error: ", error);
      setIsLoadingSubmit(false);
      dispatch(showSnackBar("An error occurred!", 'error'));
    }  
  };

  const fetchUsersData = useCallback(async (searchString) => {    
    setIsLoading(true);

    let fetchFunction = null;
    switch (role) {
      case 'Student':
        fetchFunction = isActionView ? ProfilesService.listStudentsFromCourseId : ProfilesService.listStudentsExcludingCourseId;      
        break;
      case 'Educator':
        fetchFunction = isActionView ? ProfilesService.listTeachersFromCourseId : ProfilesService.listTeachersExcludingCourseId;
        break;
      default:
        break;
    };

    try {
      const filters = {};
      if (searchString) {
        filters.q = searchString;
      }
      const result = await fetchFunction(courseId, 
        {
          fields: "id,first_name,last_name,email,profile_type,phone,is_active",
          limit: paginationLimit,
          offset: calcOffset(page, paginationLimit)
        }, 
        filters      
      );
      setUsersList(result.data.results);
      setIsLoading(false);
      setCountPages(calcCountPages(result, paginationLimit));      
    } catch (error) {      
      console.log("Error", error)
      setUsersList([]);
    }
  }, [courseId, isActionView, page, role]);

  const getCurrentUsersAssigned = useCallback(async () => {
    let field = null;
    field = role === 'Student' ? 'students' : 'teachers';
    try {      
      const result = await CoursesService.retrieveCourse(
        courseId,
        {
          fields: `id,${field}`,
        }
      );
      setAssginedUsers(result.data[field]);
    } catch (error) {
      setAssginedUsers([]);
    }
  }, [courseId, role]);

  const handleAddUser = (user) => {
    setSelectedUsers([...selectedUsers, user]);
  }
  const handleResetSelectedUsers = () => {
    setSelectedUsers([]);
  }
  const handleRemoveUser = (user) => {
    const newSelectedUsers = selectedUsers.filter((item, index) => item.id !== user.id);    
    setSelectedUsers(newSelectedUsers);
  }

  useEffect(() => { 
    // Query Params changued
    fetchUsersData();
    getCurrentUsersAssigned();
  }, [fetchUsersData, getCurrentUsersAssigned, location.search]);

  return (
    <div className="student-selection">
      <Grid container spacing={3} direction="row">
      {/* Headers */}      
      <Grid item xs={12}>
      <div className="student-selection__header">
      <div className="student-selection__header__actions">
        <TextField id="standard-search" type="search"  fullWidth placeholder="First name, last name or Email." color="primary"  onChange={onSearchChanged} variant="outlined"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),            
          shrink: "true",
        }}
        />
      </div>
      </div>
      </Grid>
      
      {/* Users selection chips */}
      <Grid item xs={12}>
        <ChipSelection 
          role={role} 
          selectedChips={selectedUsers} 
          handleRemoveChip={handleRemoveUser} 
          action={action} 
          onSave={updateCourseStudents} 
          onReset={handleResetSelectedUsers} 
          isLoading={isLoadingSubmit}
        />
      </Grid>

      {/* Users List */}
      <Grid item xs={12}>
        <div className="student-selection__list">
          {/* Body */}
          <div className="content">            
            {isLoading ? (
                // Generate 5 courses of loading data
                usersLoading.map(i => <UserItem key={i} loading />)
              ) : // Show courses
              usersList.length > 0 ? (
                usersList.map(user => (
                  <UserSelectableItem
                    data={user}
                    key={user.id}
                    onAddUser={handleAddUser}
                    onRemoveUser={handleRemoveUser}
                    action={action}
                    isSelected={selectedUsers.some((item) => item.id === user.id)}
                    isLoadingSubmit={isLoadingSubmit}
                  />
                ))
              ) : (
                // Show Empty courses
                <EmptyResult message={ isActionView ? `This Group doesn't have ${role}s assgined.` : `There aren't users to show`}/>
              )}

            <Pagination
              page={page}
              count={countPages}
              color="primary"
              size="large"
              renderItem={item => (
                <PaginationItem
                  component={Link}
                  to={{
                    pathname: PAGINATION_URL,
                    // search: `${query}${item.page === 1 ? "" : `&page=${item.page}`}`,
                    search: `${query}`,
                    state: {  // location state
                      page: item.page,
                      selectedUsers,
                      update: false, 
                    },
                  }}
                  {...item}
                />
              )}
            />
          </div>
        </div>
      </Grid>
    </Grid>
    </div>
  )

}

export default ProfileSelection;